import {fetchQuery, type GraphQLTaggedNode, type OperationType, type PreloadableConcreteRequest} from 'relay-runtime'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {clientSideRelayFetchQueryRetained} from '@github-ui/relay-environment'
import {INTERNAL_ONLY_ATTRIBUTES} from './create-query-cache'

export const DEFAULT_RELAY_CACHE_TTL = 2 * 7 * 24 * 60 * 60 * 1000 // 2 weeks in milliseconds

export function fetchQueryWithCache<T extends OperationType>(
  ...args: [...Parameters<typeof fetchQuery<T>>, number?, string?, boolean?, string[]?]
) {
  const [environment, query, variables, options, ttl, preheatSource, skipCache, excludeFromCacheKey] = args
  const defaultValues = getDefaultValues(query)

  return fetchQuery<T>(environment, query, variables, {
    ...options,
    networkCacheConfig: {
      metadata: {
        ttl,
        defaultValues,
        preheatSource,
        skipCache,
        [INTERNAL_ONLY_ATTRIBUTES.EXCLUDE_FROM_CACHE_KEY]: excludeFromCacheKey,
      },
    },
  })
}

export function clientSideRelayFetchQueryRetainedWithCache<T extends OperationType>(
  ...args: [...Parameters<typeof clientSideRelayFetchQueryRetained<T>>, number?, string[]?]
) {
  const [options, ttl, excludeFromCacheKey] = args
  const defaultValues = getDefaultValues(options.query)

  return clientSideRelayFetchQueryRetained<T>({
    ...options,
    metadata: {
      ...options.metadata,
      ttl,
      defaultValues,
      [INTERNAL_ONLY_ATTRIBUTES.EXCLUDE_FROM_CACHE_KEY]: excludeFromCacheKey,
    },
  })
}

export function getDefaultValues<TQuery extends OperationType>(
  query: GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>,
): Record<string, unknown> | undefined {
  const defaultValues: Record<string, unknown> = {}
  if ('operation' in query) {
    const argumentDefinitions = query.operation.argumentDefinitions
    for (const argDef of argumentDefinitions) {
      if (argDef.defaultValue !== undefined && argDef.defaultValue !== null) {
        defaultValues[argDef.name] = argDef.defaultValue
      }
    }
  }
  return Object.keys(defaultValues).length > 0 ? defaultValues : undefined
}

type CacheForceRefreshProps = {
  query: GraphQLTaggedNode
  number: number
  owner: string
  repo: string
}

export function cacheForceRefresh(
  relayEnvironment: Parameters<typeof fetchQuery>[0],
  {query, number, owner, repo}: CacheForceRefreshProps,
) {
  const variables = {
    owner,
    repo,
    number,
    count: 15,
  }

  fetchQueryWithCache(
    relayEnvironment,
    query,
    variables,
    {fetchPolicy: 'network-only'},
    DEFAULT_RELAY_CACHE_TTL,
    'force_refresh',
    true, // Skip cache
  ).toPromise()
}
